import '../../css/Home.css';
import { useHistory } from 'react-router-dom'
import { OrganizationType, UserLogin } from '../../types'
import { useOrganizationContext } from '../../context/OrganizationContext';
import { useUserContext } from '../../context/UserContext';
import { useState } from 'react';
import { CreateUserOrgRole } from '../login/CreateUserOrgRole';


type Props = {
  organizations: OrganizationType[];
}


export const OrganizationsList = ({ organizations }: Props) => {
  const history = useHistory()
  const orgContext = useOrganizationContext()
  const userCtx = useUserContext()
  const [userHasNoAccount, setUserHasNoAccount] = useState<boolean>(false)
  const [data, setData] = useState<UserLogin>({orgId: "", usrId: "", user: null})
  
  if (organizations.length === 0) {
    return (<div className="loader--loading" style={{ height: '100vh' }}></div>)
  }

  if (history.location.state != undefined) {
    const {url, imageid} = history.location.state as {url: string, imageid: string}

    if (url != undefined && imageid != undefined) {
      history.push({pathname: url, state: {imageid: imageid}})
    } else {
      console.error("Couldn't reroute to museum")
    }
  }

  if (userCtx?.loggedInUser === null) {
    return(  
      <div className="organizations">
        {organizations.map(organization => (
      <div key={organization.id} className="organzation" style={{ backgroundColor: `${organization.color}` }} onClick={() => {
        orgContext?.addOrganizationToContext(organization)
        history.push(`organization/${organization.id}`)
      }}>
        <h3>{organization.name}</h3>
      </div>
    ))}
    </div>
    )
  }

  const __handleLoggedInUser = (org: OrganizationType) => {
    const usr = userCtx?.loggedInUser
    const orgId = org.id
    
    setData({orgId: org.id, usrId: usr!.id, user: usr!})

    const roles = usr?.roles

    let hasAccountAtOrg = false
    if (roles) {
      roles.forEach(role => {
        if (role.organizationId == orgId) {
          hasAccountAtOrg = true
        }
      })
    }
    
    if (hasAccountAtOrg) {
        orgContext?.addOrganizationToContext(org)
        history.push(`organization/${org.id}`)
    } else {
      orgContext?.addOrganizationToContext(org)
      setUserHasNoAccount(true)
    }
  }

  return (
    <div className="App">
      <div className="organizations">
        {organizations.map(organization => (
          !(userCtx?.suspendedOrgs.includes(organization.id)) ? (
            <div key={organization.id} className="organzation" style={{ backgroundColor: `${organization.color}` }} onClick={() => {__handleLoggedInUser(organization)}}>
              <h3>{organization.name}</h3>
            </div>
          ) : ""
        ))}
      </div>
      <div>
      <>
        {userHasNoAccount && (
          <CreateUserOrgRole
            userInfo={data}
            onClose={() => setUserHasNoAccount(false)}
          />
        )}
      </>
      </div>
    </div>
  );
}


